export default [
  { text: "+14:00", value: "+14:00" },
  { text: "+13:45", value: "+13:45" },
  { text: "+13:00", value: "+13:00" },
  { text: "+12:45", value: "+12:45" },
  { text: "+12:00", value: "+12:00" },
  { text: "+11:30", value: "+11:30" },
  { text: "+11:00", value: "+11:00" },
  { text: "+10:30", value: "+10:30" },
  { text: "+10:00", value: "+10:00" },
  { text: "+09:30", value: "+09:30" },
  { text: "+09:00", value: "+09:00" },
  { text: "+08:45", value: "+08:45" },
  { text: "+08:00", value: "+08:00" },
  { text: "+07:00", value: "+07:00" },
  { text: "+06:30", value: "+06:30" },
  { text: "+06:00", value: "+06:00" },
  { text: "+05:45", value: "+05:45" },
  { text: "+05:30", value: "+05:30" },
  { text: "+05:00", value: "+05:00" },
  { text: "+04:30", value: "+04:30" },
  { text: "+04:00", value: "+04:00" },
  { text: "+03:30", value: "+03:30" },
  { text: "+03:00", value: "+03:00" },
  { text: "+02:30", value: "+02:30" },
  { text: "+02:00", value: "+02:00" },
  { text: "+01:00", value: "+01:00" },
  { text: "±00:00", value: "+00:00" },
  { text: "-01:00", value: "-01:00" },
  { text: "-02:00", value: "-02:00" },
  { text: "-02:30", value: "-02:30" },
  { text: "-03:00", value: "-03:00" },
  { text: "-04:00", value: "-04:00" },
  { text: "-05:00", value: "-05:00" },
  { text: "-06:00", value: "-06:00" },
  { text: "-07:00", value: "-07:00" },
  { text: "-08:00", value: "-08:00" },
  { text: "-09:00", value: "-09:00" },
  { text: "-09:30", value: "-09:30" },
  { text: "-10:00", value: "-10:00" },
  { text: "-11:00", value: "-11:00" },
  { text: "-12:00", value: "-12:00" },
];
